import { endpoints } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { Auth } from '../../autentication/Auth';

@Injectable()
export class ChangePassService {

	constructor(private http: HttpClient) { }

	changePassword(changePassData: any): Observable<any> {
		const oldPassword = changePassData.oldPassword;
		const password = changePassData.passwords.password;

		const dataResetPassword = {
			SenhaAnterior: oldPassword,
			SenhaNova: password
		};

		return this.http.put( endpoints.accounts.updateAccessPassword, dataResetPassword);

	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/change-pass/change-pass.service.ts